<script setup>

    import { ref, onMounted, watch } from 'vue';
    import { useEngagementStore } from '@/Stores'
    import { storeToRefs } from 'pinia'

    import { EnvelopeIcon, GiftIcon } from '@heroicons/vue/24/outline'
    import LatteLargeGiftIcon from '@/Icons/LatteLargeGiftIcon.vue'

    const engagementStore = useEngagementStore()
    const { giftOptions } = storeToRefs(engagementStore)


    const emit = defineEmits(['update:modelValue'])

    const props = defineProps({
        loading: {
            type: Boolean,
            default: false
        },
        modelValue: {
            type: Number,
            default: 1
        }
    })

    const selectedGift = ref(props.modelValue)

    watch(() => selectedGift.value, (newValue) => {
        if (!newValue) {
            return;
        }
        emit('update:modelValue', newValue)
    })

    onMounted(() => {
        selectedGift.value = giftOptions.value.find(option => option.id === props.modelValue)?.id || null
    })

</script>

<template>

    <fieldset class="w-full">

        <div class="grid grid-cols-3 gap-3">
            <label
                v-for="giftOption in giftOptions"
                :key="giftOption.id"
                class="group relative flex items-center justify-center rounded-md border text-lifeworx-blue-600/80 border-lifeworx-blue-600/20 bg-zinc-75 p-2 cursor-pointer select-none hover:bg-lifeworx-blue-600/20 hover:text-lifeworx-blue-600 hover:border-lifeworx-blue-600 hover:border-2 has-[:checked]:border-2 has-[:checked]:border-lifeworx-blue-600 has-[:disabled]:border-gray-400 has-[:checked]:bg-lifeworx-blue-600/80 has-[:checked]:text-white has-[:checked]:cursor-default has-[:disabled]:bg-gray-200 has-[:disabled]:opacity-25 has-[:focus-visible]:outline has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-lifeworx-blue-600"
            >
                <input
                    type="radio"
                    name="gift-option"
                    v-model="selectedGift"
                    :value="giftOption.id"
                    :checked="selectedGift === giftOption.id"
                    class="peer absolute inset-0 appearance-none hidden focus:outline focus:outline-0"
                />

                <div class="flex flex-col justify-center items-center scale-90 group-hover:scale-100 peer-checked:scale-100 [&>div]:opacity-75 peer-checked:[&>div]:opacity-100 transition-all duration-200 ease-in-out">
                    <div class="h-8">
                        <EnvelopeIcon
                            v-if="giftOption.icon === 'note-card'"
                            class="size-7 mt-0.5"
                        />
                        <GiftIcon
                            v-if="giftOption.icon === 'gift-small'"
                            class="size-7 mt-0.5"
                        />
                        <LatteLargeGiftIcon
                            v-if="giftOption.icon === 'gift-large'"
                            class="h-7 mt-0.5 opacity-85"
                        />
                    </div>
                    <span class="font-semibold text-sm">{{ giftOption.label }}</span>
                </div>

            </label>
        </div>
    </fieldset>

</template>
